import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Button, Steps, message } from "antd";
import "react-calendar/dist/Calendar.css";
import Select from "react-select";
import "./AppointmentPage.css";
import Header from '../Shared/Header/Header';
import Footer from '../Shared/Footer/Footer';
import AppointmentDetails from './AppointmentDetails';
import AppointmentDetailsDoctor from './AppointmentDetailsDoctor';
import PersonalInfo from './PersonalInfo';
import AppointmentSummary from './AppointmentSummary';

import { UserContext } from "../../context/UserContext";
import { useAuth } from "../../context/AuthContext";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AppointmentPage = () => {
  // extract potential doctor name from link
  const query = new URLSearchParams(useLocation().search);
  const doctorFirstName = query.get("firstName");
  const doctorLastName = query.get("lastName");

  const [current, setCurrent] = useState(0);

  const [selectedService, setSelectedService] = useState(null);
  const [prevSelectedService, setPrevSelectedService] = useState(null);

  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [drawnDoctor, setDrawnDoctor] = useState(null);
  const [prevDoctor, setPrevDoctor] = useState(null);

  const [selectedDate, setSelectedDate] = useState(null);
  const [prevSelectedDate, setPrevSelectedDate] = useState(null);

  const [selectedTime, setSelectedTime] = useState("");
  const [prevSelectedTime, setPrevSelectedTime] = useState("");

  const [serviceCost, setServiceCost] = useState("");
  const [serviceTimes, setServiceTimes] = useState([]);
  const [selectedServiceTime, setSelectedServiceTime] = useState([]);
  const [prevSelectedServiceTime, setPrevSelectedServiceTime] = useState([]);

  const [availableDoctors, setAvailableDoctors] = useState([]);
  const [availableDisorders, setAvailableDisorders] = useState([]);
  const [availableDates, setAvailableDates] = useState([]);
  const [availableTimes, setAvailableTimes] = useState([]);

  const [IsDisable, setIsDisable] = useState(true); // for PersonalInfo validation
  const [isConfirmDisable, setIsConfirmDisable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [appointmentCost, setAppointmentCost] = useState(false);
  const [isCheck, setIsChecked] = useState(false); // check the 'accept privacy and conditions' box

  // info about the user 
  const { user, logout } = useAuth(UserContext);
  const [selectValue, setSelectValue] = useState(user);
  const [additionalInfo, setAdditionalInfo] = useState("");
  const [internalTransactionId, setInternalTransactionId] = useState("");

  // possibility to reserve without login
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // formatting date to YYYY-MM-DD format
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
    const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits
    return `${year}-${month}-${day}`; // Return the formatted date
  };

  const formatDateYYYYMMDD = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
    const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits
    return `${year}${month}${day}`; // Return the formatted date
  };

  // formatting datetime to YYYY-MM-DD HH:MI:SS format
  const formatDateTime = (date) => {
    return date.getFullYear() +
      "-" + String(date.getMonth() + 1).padStart(2, "0") +
      "-" + String(date.getDate()).padStart(2, "0") +
      "T" + String(date.getHours()).padStart(2, "0") +
      ":" + String(date.getMinutes()).padStart(2, "0") +
      ":" + String(date.getSeconds()).padStart(2, "0");
  };


  const next = () => {
    setCurrent(current + 1);
    if (current === 0) {
      updateDoctorsAvailability(true, false, 5);
      updatePrevData();
    }

    // if (current === 2) {
    //   handleSubmitAppointment();
    // }
  };

  const isNextDisabled =
    current === 0 ? (selectedTime ? false : true) : IsDisable || !selectedTime;
  const prev = () => {
    setCurrent(current - 1);
  };

  const handleChange = (e) => {
    setSelectValue({ ...selectValue, [e.target.name]: e.target.value });
  };
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };


    useEffect(() => {
    if (selectValue) {
      const {
        firstName,
        lastName,
        email,
        phoneNumber,
        city,
        zipCode,
        street,
        addressNo,
        state,
        country
      } = selectValue;

      const isInputEmpty = !firstName || !lastName || !email || !phoneNumber 
                          || !city || !zipCode || !street || !addressNo
                          || !state || !country;
      const isConfirmInputEmpty = !isCheck;

      setIsDisable(isInputEmpty);
      setIsConfirmDisable(isConfirmInputEmpty);
    } else {
      setIsDisable(true);
      setIsConfirmDisable(true);
    }
  }, [selectValue, isCheck]);



  // update doctors_availability table
  const updateDoctorsAvailability = async (updatePrev=true, isConfirmedFlg=false, reservationTime=5) => {
    if (!(selectedDoctor || drawnDoctor) || !selectedDate || !selectedTime) {
      console.error("Missing required fields for reservation.");
      return;
    }

    const formatAppointmentTime = (date, time, duration) => {
      const [hour, minute] = time.split(":").map(Number);
      const startTime = new Date(date);
      startTime.setHours(hour, minute, 0);
  
      const endTime = new Date(startTime);
      endTime.setMinutes(startTime.getMinutes() + duration);
  
      return {
        formattedStart: startTime.toTimeString().split(" ")[0], // start time in format "HH:mm:ss"
        formattedEnd: endTime.toTimeString().split(" ")[0], // end time in format "HH:mm:ss"
      };
    };


    const { formattedStart: timeStart, formattedEnd: timeEnd } = formatAppointmentTime(
      selectedDate,
      selectedTime,
      selectedServiceTime
    );
  
    const doctorId = (selectedDoctor && selectedDoctor.value !== "all") ? selectedDoctor.value : drawnDoctor?.value;
    const formattedDate = formatDate(selectedDate);
  
    // console.log("Service:", selectedService);
    // console.log("selectedDoctor ID:", selectedDoctor?.value);
    // console.log("selectedDoctor ID:", drawnDoctor?.value);
    // console.log("Doctor ID:", doctorId);
    // console.log("Date:", formattedDate);
    // console.log("Time Start:", timeStart);
    // console.log("Time End:", timeEnd);
  
    const reservationValidTo = new Date();
    reservationValidTo.setMinutes(reservationValidTo.getMinutes() + reservationTime);

    const requestBodyNew = {
      status: true,
      reservationValidTo: formatDateTime(reservationValidTo),
      userId: user ? user.id : null,
      doctorId: doctorId,
      date: formattedDate,
      timeStart: timeStart,
      timeEnd: timeEnd,
      isConfirmed: isConfirmedFlg
    };
  
    let requestBodyOld = null;
  
    if (updatePrev && prevSelectedService && prevDoctor && prevSelectedDate && prevSelectedTime) {
      const { formattedStart: prevTimeStart, formattedEnd: prevTimeEnd } = formatAppointmentTime(
        prevSelectedDate,
        prevSelectedTime,
        prevSelectedServiceTime
      );
  
      requestBodyOld = {
        status: false,
        reservationValidTo: null,
        userId: null,
        doctorId: prevDoctor.value,
        date: formatDate(prevSelectedDate),
        timeStart: prevTimeStart,
        timeEnd: prevTimeEnd,
        isConfirmed: false
      };
    }

    try {
      // Send the first request (if it exists)
      if (requestBodyOld) {
        const responseOld = await fetch(`${API_BASE_URL}/api/doctorsAvailability/reserve`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBodyOld),
        });
    
        if (!responseOld.ok) {
          throw new Error("Failed to cancel previous reservation.");
        }
      }
    
      // Send the second request (new reservation)
      const responseNew = await fetch(`${API_BASE_URL}/api/doctorsAvailability/reserve`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBodyNew),
      });
    
      if (responseNew.ok) {
//         message.success("Slot successfully reserved!");
      } else {
//         message.error("Failed to reserve the slot!");
      }
    } catch (error) {
      console.error("Error updating availability:", error);
//       message.error("An error occurred while reserving the slot.");
    }
  };


  const updatePrevData = () => {
    setPrevSelectedService(selectedService); // previous service saved to unlock in db 
    setPrevSelectedServiceTime(selectedServiceTime); // previous service time saved to unlock in db
    setPrevDoctor(selectedDoctor.value !== 'all' ? selectedDoctor : drawnDoctor);
    
    setPrevSelectedDate(selectedDate);
    setPrevSelectedTime(selectedTime);
  }

  useEffect(() => {
  if (!user) {
    setIsPopupOpen(true); // show popup only if user is null
  }
}, [user]);


  const steps = [
    {
      title: "Szczegóły Wizyty",
      content: (
        (!doctorFirstName || !doctorLastName) ? 
          <AppointmentDetails
            user={user}
            selectedService={selectedService}
            setSelectedService={setSelectedService}

            selectedDoctor={selectedDoctor}
            setSelectedDoctor={setSelectedDoctor}
            drawnDoctor={drawnDoctor}
            setDrawnDoctor={setDrawnDoctor}

            handleDateChange={handleDateChange}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}

            setServiceCost={setServiceCost}
            serviceTimes={serviceTimes}
            setServiceTimes={setServiceTimes}
            selectedServiceTime={selectedServiceTime}
            setSelectedServiceTime={setSelectedServiceTime}

            availableDoctors={availableDoctors}
            setAvailableDoctors={setAvailableDoctors}
            availableDisorders={availableDisorders}
            setAvailableDisorders={setAvailableDisorders}
            availableDates={availableDates}
            setAvailableDates={setAvailableDates}
            selectedTime={selectedTime}
            setSelectedTime={setSelectedTime}
            availableTimes={availableTimes}
            setAvailableTimes={setAvailableTimes}

            isPopupOpen={isPopupOpen}
            setIsPopupOpen={setIsPopupOpen}
          />
        :
        <AppointmentDetailsDoctor
          user={user}
          selectedService={selectedService}
          setSelectedService={setSelectedService}

          doctorFirstName={doctorFirstName}
          doctorLastName={doctorLastName}
          selectedDoctor={selectedDoctor}
          setSelectedDoctor={setSelectedDoctor}

          handleDateChange={handleDateChange}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}

          setServiceCost={setServiceCost}
          serviceTimes={serviceTimes}
          setServiceTimes={setServiceTimes}
          selectedServiceTime={selectedServiceTime}
          setSelectedServiceTime={setSelectedServiceTime}

          availableDoctors={availableDoctors}
          setAvailableDoctors={setAvailableDoctors}
          availableDisorders={availableDisorders}
          setAvailableDisorders={setAvailableDisorders}
          availableDates={availableDates}
          setAvailableDates={setAvailableDates}
          selectedTime={selectedTime}
          setSelectedTime={setSelectedTime}
          availableTimes={availableTimes}
          setAvailableTimes={setAvailableTimes}

          isPopupOpen={isPopupOpen}
          setIsPopupOpen={setIsPopupOpen}
        />
      ),
    },
    {
      title: "Wymagane Informacje",
      content: (
        <PersonalInfo 
          handleChange={handleChange} 
          selectValue={selectValue}
          additionalInfo={additionalInfo}
          setAdditionalInfo={setAdditionalInfo}
        />
      ),
    },
    {
      title: "Podsumowanie",
      content: (
        <AppointmentSummary
          selectedService={selectedService}
          serviceCost={serviceCost}
          selectedDoctor={selectedDoctor}
          drawnDoctor={drawnDoctor}
          selectedDate={selectedDate}
          selectedTime={selectedTime}
          selectValue={selectValue}
          appointmentCost={appointmentCost}
          isCheck={isCheck}
          setIsChecked={setIsChecked}
        />
      ),
    },
  ];



  const createAppointment = async (appointmentRequest, addressRequest) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/appointment/createAppointment`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
              appointmentRequest,
              addressRequest
            }),
        });

        if (!response.ok) {
            throw new Error("Failed to create appointment");
        }

        const data = await response.json();
    } catch (error) {
        console.error("Error:", error);
    }
  };


  const handleSubmitAppointment = async (e) => {
      // e.preventDefault();
      setInternalTransactionId(`${formatDateYYYYMMDD(selectedDate)}${Math.floor(Math.random() * 1_000_000) + 1}`);
      
      if (!selectValue) {
          console.error("selectValue is empty");
          return;
      }

      const appointmentData = {
          description: additionalInfo,
          dateTime: `${formatDate(selectedDate)}T${selectedTime}`,
          disorderId: selectedService.value,
          doctorId: (selectedDoctor && selectedDoctor.value !== "all") ? selectedDoctor.value : drawnDoctor?.value,
          userId: user ? user.id : null,
          internalTransactionId: internalTransactionId
      }
      
      const addressData = {
            country: selectValue?.country || "",
            state: selectValue?.state || "",
            city: selectValue?.city || "",
            zipCode: selectValue?.zipCode || "",
            street: selectValue?.street || "",
            addressNo1: selectValue?.addressNo1 || "",
            addressNo2: selectValue?.addressNo2 || "",
            link: selectValue?.link || "",
            isPaid: selectValue?.isPaid || false,
            paymentDttm: selectValue?.paymentDttm || null
      }


      await createAppointment(appointmentData, addressData);
  };


  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));


  /** 1) Create the appointment in your DB, then call PayU endpoint and redirect */
  const handlePayment = async (appointmentId, transactionId) => {
    setIsLoading(true);
    try {
      const resp = await fetch(`${API_BASE_URL}/api/payu/create-order`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          extOrderId: transactionId,
          continueUrl: `${window.location.origin}/#/thank-you/`,
          notifyUrl: `${API_BASE_URL}/api/payu/notify`,
          // notifyUrl: 'https://synavie.pl/api/payu/notify',
          totalAmount: Math.round(serviceCost.find(entry => entry.value=selectedService.value).label * 100), // grosze
          currencyCode: "PLN",
          description:
            selectedService.label === "Konsultacje psychologiczne"
              ? selectedService.label
              : `Diagnoza ${selectedService.label}, diagnosta: ${
                  selectedDoctor.value !== "all" ? selectedDoctor.label : drawnDoctor.label
                }`,
          buyer: {
            email: selectValue.email,
            phone: selectValue.phoneNumber,
            firstName: selectValue.firstName,
            lastName: selectValue.lastName,
            language: 'pl'
          },
          products: [
            {
              name: selectedService.label,
              unitPrice: Math.round(serviceCost.find(entry => entry.value=selectedService.value).label * 100).toString(),
              quantity: "1",
              virtual: true
            }
          ]
        }),
      });

      if (!resp.ok) throw new Error("Payment init failed");
      const { redirectUri } = await resp.json();
      window.location.href = redirectUri;
    } catch (err) {
      console.error(err);
      message.error("Nie udało się zainicjować płatności.");
    } finally {
      setIsLoading(false);
    }
  };


  /** 2) When user clicks “Płatność” */
  const handleConfirmSchedule = async () => {

    //generate internal transaction id - extOrderId in PayU request/response
    const internalTransactionId = `${formatDateYYYYMMDD(selectedDate)}${Math.floor(Math.random() * 1_000_000) + 1}`;
    
    // 2a) update your doctors_availability (reserve & confirm)
    await updateDoctorsAvailability(false, true, 24 * 60);

    // 2b) create the appointment in your system
    const appointmentData = {
      description: additionalInfo,
      dateTime: `${formatDate(selectedDate)}T${selectedTime}`,
      disorderId: selectedService.value,
      doctorId: (selectedDoctor && selectedDoctor.value !== "all") ? selectedDoctor.value : drawnDoctor?.value,
      userId: user ? user.id : null,
      internalTransactionId: internalTransactionId,
      patientFirstName: selectValue.firstName,
      patientLastName: selectValue.lastName,
      patientPhoneNumber: selectValue.phoneNumber,
      patientEmail: selectValue.email

    };
    const addressData = {
      country: selectValue.country,
      state: selectValue.state,
      city: selectValue.city,
      zipCode: selectValue.zipCode,
      street: selectValue.street,
      addressNo1: selectValue.addressNo,
      addressNo2: selectValue.addressNo2 || "",
      // link: selectValue.link || ""
      // isPaid: false,
      // paymentDttm: null
    };

    try {
      const createResp = await fetch(`${API_BASE_URL}/api/appointment/createAppointment`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ appointmentRequest: appointmentData, addressRequest: addressData })
      });
      if (!createResp.ok) throw new Error("Nie udało się utworzyć wizyty");
      const { id: appointmentId } = await createResp.json();
      
      // 2c) now start PayU checkout
      handlePayment(appointmentId, internalTransactionId);

    } catch (err) {
      console.error(err);
      message.error("Błąd przy tworzeniu wizyty.");
    }
  };


  // const handleConfirmSchedule = () => {
  //   const obj = {};
  //   obj.patientInfo = {
  //     firstName: selectValue.firstName,
  //     lastName: selectValue.lastName,
  //     email: selectValue.email,
  //     phone: selectValue.phone,
  //     pesel: selectValue.pesel,
  //     // patientId: role !== '' && role === 'patient' ? data.id : undefined,
  //     scheduleDate: selectedDate,
  //     scheduleTime: selectedTime,
  //   };

  //   updateDoctorsAvailability(false, true, 24*60);
  //   // createAppointmentByUnauthenticateUser(obj)
  // };
  

  return (
    <div className="page-layout">
      <Header />
      <div className="container" style={{ marginTop: "4rem", marginBottom: "4rem" }}>
        <div
          className="container"
          style={{ marginBottom: "8rem", marginTop: "4rem" }}
        >
          <div className="steps-container">
            <Steps current={current} items={items} />
            <div className="mb-5 mt-3 mx-3">{steps[current].content}</div>
            <div className="text-end mx-3">
              {current > 0 && (
                <Button
                  className="iBtn-appointment-active"
                  style={{ margin: "0 8px" }}
                  size="large"
                  onClick={() => prev()}
                >
                  Wróć
                </Button>
              )}

              {current === steps.length - 1 && (
                <Button
                  className={
                    isConfirmDisable
                      ? "iBtn-appointment-disabled"
                      : "iBtn-appointment-active"
                  }
                  type="primary"
                  size="large"
                  disabled={isConfirmDisable}
                  loading={isLoading}
                  onClick={handleConfirmSchedule}
                >
                  Płatność
                </Button>
              )}

              {current < steps.length - 1 && (
                <Button
                  className={
                    isNextDisabled
                      ? "iBtn-appointment-disabled"
                      : "iBtn-appointment-active"
                  }
                  type="primary"
                  size="large"
                  disabled={
                    current === 0
                      ? selectedTime
                        ? false
                        : true
                      : IsDisable || !selectedTime
                  }
                  onClick={() => next()}
                >
                  Dalej
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AppointmentPage;
